import React from 'react'
import { useTranslation } from '@mc/i18n'
import { InlineVideoPlayer } from 'pages/sessions/components/InlineVideoPlayer'
import {
  trackCampClassTrailerClick,
  getCampClassTrailerVideoEventAttributes,
} from 'pages/sessions/events'
import type { Camp } from '../../types'

export const InlineTrailer = ({ camp }: { camp: Camp }) => {
  const { t } = useTranslation('@mc/next')

  if (!camp.trailer?.brightcoveVideoId || !camp.trailer?.mediaUuid) return null

  return (
    <InlineVideoPlayer
      videoId={camp.trailer?.brightcoveVideoId}
      mediaUuid={camp.trailer?.mediaUuid}
      onTileClick={() =>
        trackCampClassTrailerClick({
          ...camp,
          contentId: `${camp.id}_${
            camp.trailer?.brightcoveVideoId ?? camp.trailer?.mediaUuid
          }`,
        })
      }
      contentId={`${camp.id}_${
        camp.trailer?.brightcoveVideoId ?? camp.trailer?.mediaUuid
      }`}
      contentTitle='Camp Class Trailer'
      contentType='Camp Trailer'
      extraTrackingInfo={getCampClassTrailerVideoEventAttributes({
        ...camp,
        contentId: `${camp.id}_${
          camp.trailer?.brightcoveVideoId ?? camp.trailer?.mediaUuid
        }`,
      })}
      pageType='class-page'
      playAriaLabel={t('sessions.trailer.course', {
        session: camp.nameplateTitle,
      })}
    />
  )
}
